import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { QRCodeSVG } from 'qrcode.react'
import { Circles } from 'react-loader-spinner'
import moment from 'moment'
import { getPassDetailsById } from '../../redux/actions/passDetailsAction'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { errorMessage } from '../../constants/errorMessage'
import { phoneMasker } from '../../utils/helper'
import PassWalletButtons from '../../components/global/PassWalletButtons'
import { APICONFIG } from '../../redux/config/apiConfig'

function PassDetails(props) {
    const { dispatch, partnerDetails, notify } = props
    const { passId } = useParams()
    const [passData, setPassData] = useState(EMPTY_OBJECT)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const [navHeight, setNavHeight] = useState(56)
    
    useEffect(() => {
        const updateNavHeight = () => {
            const nav = document.querySelector('nav.fixed-top')
            if (nav) setNavHeight(nav.offsetHeight)
        }
        updateNavHeight()
        window.addEventListener('resize', updateNavHeight)
        return () => window.removeEventListener('resize', updateNavHeight)
    }, [])

    useEffect(() => {
        if (passId) {
            dispatch(getPassDetailsById(passId)).then((res) => {
                setIsLoading(false)
                if (res?.id) {
                    setPassData(res)
                    setError(null)
                } else {
                    setPassData(null)
                    setError(res?.message || res?.errors?.message || errorMessage?.somethingWentWrong)
                }
            }).catch((err) => {
                setPassData(null)
                setIsLoading(false)
                setError(err?.errors?.message || err?.message || errorMessage?.somethingWentWrong)
            })
        }
    }, [passId])

    const qrValue = passData?.pass_code || passId
    const isActive = passData?.pass_status === 'Active'

    return (
        <div className="d-flex flex-column flex-grow-1" style={{ paddingTop: navHeight }}>
            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center flex-grow-1">
                    <Circles height="60" width="60" color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} />
                </div>
            ) : error ? (
                <div className="d-flex justify-content-center align-items-center flex-grow-1">
                    <div className="col-12 col-md-8 col-lg-6 px-3">
                        <div className="alert alert-danger text-center" role="alert">
                            <i className="fa fa-exclamation-circle me-2"></i>
                            {error}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container py-4">
                    <ul className="list-unstyled mb-0">
                        <li className={`TicketCardStyle ${isActive ? 'active border-success' : 'inactive border-secondary'}`}>

                            {/* Header */}
                            <div className="d-flex justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row gap-2 mb-4">
                                <div className="d-flex gap-2 align-items-center">
                                    <i className={`fa fa-id-card fa-2x ${isActive ? 'text-success' : 'text-secondary'}`}></i>
                                    <div>
                                        <h4 style={{ lineHeight: '0.8' }} className={`mb-0 fw-bold ${isActive ? 'text-success' : 'text-secondary'}`}>
                                            Pass #{passData?.pass_code || passId}
                                        </h4>
                                        {passData?.pass_name && (
                                            <small className="text-muted">{passData.pass_name}</small>
                                        )}
                                    </div>
                                </div>
                                <div className="text-sm-end">
                                    Status - <span className={`fw-bold ${isActive ? 'text-success' : 'text-secondary'}`}>
                                        {passData?.pass_status || '—'}
                                    </span>
                                </div>
                            </div>

                            <div className="border border-dashed my-3 d-block w-100"></div>

                            {/* 3-column body */}
                            <div className="row g-4 align-items-start">

                                {/* Column 1 */}
                                <div className="col-12 col-sm-6 col-md-4">
                                    {passData?.facility?.full_name && (
                                        <div className="mb-3 lh-08">
                                            <small className="text-muted d-block mb-1">Facility</small>
                                            <span className="fw-semibold">{passData.facility.full_name}</span>
                                        </div>
                                    )}
                                    <div className="mb-3 lh-08">
                                        <small className="text-muted d-block mb-1">Start Date</small>
                                        <span className="fw-semibold">
                                            {passData?.start_date ? moment(passData.start_date).format('MM/DD/YYYY') : '—'}
                                        </span>
                                    </div>
                                    <div className="mb-3 lh-08">
                                        <small className="text-muted d-block mb-1">Valid Till</small>
                                        <span className="fw-semibold">
                                            {passData?.end_date ? moment(passData.end_date).format('MM/DD/YYYY') : '—'}
                                        </span>
                                    </div>
                                    {passData?.ticket?.length > 0 && (() => {
                                        const uniqueTickets = [...new Set(passData.ticket.map(t => t.ticket_number))]
                                        return (
                                            <div className="mb-3 lh-08">
                                                <small className="text-muted d-block mb-1">
                                                    {uniqueTickets.length > 1 ? 'Attached Tickets' : 'Attached Ticket'}
                                                </small>
                                                <span className="fw-semibold">{uniqueTickets.join(', ')}</span>
                                            </div>
                                        )
                                    })()}
                                    {/* {passData?.remaining_days !== undefined && (
                                        <div className="mb-3 lh-08">
                                            <small className="text-muted d-block mb-1">Remaining Days</small>
                                            <span className="fw-semibold">
                                                {passData.remaining_days} / {passData.total_days}
                                            </span>
                                        </div>
                                    )} */}
                                    {/* {passData?.total && (
                                        <div className="mb-3 lh-08">
                                            <small className="text-muted d-block mb-1">Amount Paid</small>
                                            <span className="fw-semibold">${passData.total}</span>
                                        </div>
                                    )} */}
                                </div>

                                {/* Column 2 */}
                                <div className="col-12 col-sm-6 col-md-4">
                                    <div className="mb-3 lh-08">
                                        <small className="text-muted d-block mb-1">License Plate</small>
                                        <span className="fw-semibold">
                                            {passData?.license_plate || passData?.license_number || '—'}
                                        </span>
                                    </div>
                                    <div className="mb-3 lh-08">
                                        <small className="text-muted d-block mb-1">Customer Name</small>
                                        <span className="fw-semibold">{passData?.name || '—'}</span>
                                    </div>
                                    <div className="mb-3 lh-08">
                                        <small className="text-muted d-block mb-1">Phone Number</small>
                                        <span className="fw-semibold">{phoneMasker(passData?.phone) || '—'}</span>
                                    </div>
                                    {passData?.email ? (
                                        <div className="mb-3 lh-08">
                                            <small className="text-muted d-block mb-1">Email</small>
                                            <span className="fw-semibold text-primary">{passData.email}</span>
                                        </div>
                                    ) : null}
                                </div>

                                

                                {/* Column 3 – QR Code */}
                                <div className="col-12 col-md-4 d-flex flex-column align-items-center justify-content-center pt-2">
                                    {qrValue ? (
                                        <div className="border rounded p-3 text-center w-100">
                                            <div>
                                                <QRCodeSVG value={qrValue} size={170} level="H" />
                                            </div>
                                            <span className="fw-semibold d-block mt-3">{passData?.pass_code || passId}</span>
                                        </div>
                                    ) : (
                                        <p className="text-muted">QR code unavailable</p>
                                    )}
                                    <div className="p-3 text-center w-100">
                                        <div className="py-2 border-top">
                                            <PassWalletButtons
                                                ticketId={passData?.pass_code || passId}
                                                googleWalletApi={APICONFIG.getGooglePassDownload}
                                                appleWalletApi={APICONFIG.getapplePassDownload}
                                                notify={notify}
                                                partnerDetails={partnerDetails}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    )
}

PassDetails.propTypes = {
    dispatch: PropTypes.func,
    isFetching: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
}

PassDetails.defaultProps = {
    dispatch: noop,
    isFetching: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
}

function mapStateToProps({ passDetailsReducer }) {
    return {
        isFetching: passDetailsReducer?.isFetching,
    }
}

export default connect(mapStateToProps)(PassDetails)
